import { h } from 'preact';
import { useState } from 'preact/hooks';
import { TextCheckboxList } from './TextCheckboxList';
import { ColorSwatch } from './ColorSwatch';
import { RangeSlider } from './RangeSlider';
import styles from './FilterPanel.module.scss';
export function Filter({ filter, onFilterChange, layout }) {
    const [expanded, setExpanded] = useState(false);
    const filterId = filter.id.toLowerCase();
    const isColour = filter.type === 'color' || filterId.includes('colour') || filterId.includes('color');
    const isTwoColumn = isColour || filterId.includes('size');
    const selectedCount = (filter.options || []).filter(o => o.selected).length;
    const renderFilter = () => {
        if (isColour) {
            return (h(ColorSwatch, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
        }
        switch (filter.type) {
            case 'text':
            case 'select':
                return (h(TextCheckboxList, { layout: layout, options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value), columns: isTwoColumn ? 2 : 1 }));
            case 'range':
                return (h(RangeSlider, { min: filter.min || 0, max: filter.max || 1000, gap: 10, currentMin: filter.currentMin || 0, currentMax: filter.currentMax || 1000, onChange: (value) => onFilterChange(filter.id, value.toString()) }));
            default:
                return null;
        }
    };
    return (h("div", { class: styles.filterSection },
        h("div", { class: `
          ${styles.filterSectionHeader}
          ${expanded ? styles.filterSectionHeaderExpanded : ''}
        `, onClick: () => setExpanded(!expanded) },
            h("span", { class: styles.filterSectionTitle }, filter.label),
            selectedCount > 0 && h("span", { class: styles.filterSelectedCount },
                "[",
                selectedCount,
                "]"),
            h("span", { class: styles.filterToggle })),
        h("div", { class: styles.filterSectionBody }, renderFilter())));
}
